import type { AvailableOnSide } from "@tosize/shapes/src/types/finish";
import { Button, Dialog } from "@tosize/ui";
import { useIntl } from "react-intl";
import useSelectedFinishes from "../../../hooks/useSelectedFinishes";

interface Props {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	side?: AvailableOnSide;
	removeAction?: () => void;
}

export function WarningDialog({ side, open, onOpenChange, removeAction }: Props) {
	const intl = useIntl();
	const { removeFinishSides, reset } = useSelectedFinishes();

	return (
		<Dialog
			open={open}
			onOpenChange={onOpenChange}
			title={
				side
					? intl.formatMessage(
							{
								defaultMessage:
									"Hiermee worden de huidige afwerkingen van de {label} verwijderd. Weet je dat zeker?",
								id: "rnLP/k",
							},
							{ label: side.sideName },
						)
					: intl.formatMessage({
							defaultMessage: "Hiermee worden alle afwerkingen verwijderd. Weet je dat zeker?",
							id: "XxvalE",
						})
			}
		>
			<div className="flex justify-end gap-4">
				<Button
					color="white"
					onClick={() => {
						onOpenChange(false);
					}}
				>
					{intl.formatMessage({ defaultMessage: "Oeps, nee", id: "AvkTvr" })}
				</Button>
				<Button
					autoFocus
					color="danger"
					onClick={() => {
						removeAction?.();
						side ? removeFinishSides([side]) : reset();
						onOpenChange(false);
					}}
				>
					{intl.formatMessage({ defaultMessage: "Verwijderen", id: "mcAe/q" })}
				</Button>
			</div>
		</Dialog>
	);
}
